module.exports = __webpack_public_path__ + "static/media/image_11.1806ba92.png";